import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "react-feather";
import rudraLogo from "../../../assets/images/rudra-ride-logo.png";
import eduLogo from "../../../assets/images/edu-pravahaa-logo.png";

const products = [
  {
    title: "Rudra Ride",
    tag: "Smart Mobility",
    desc: "Instant booking, live tracking & secure payments.",
    logo: rudraLogo,
    link: "/rudra-rides",
    accent: "#26A9B5",
    accentGlow: "rgba(38, 169, 181, 0.35)",
  },
  {
    title: "Edu Pravahaa",
    tag: "Digital Education",
    desc: "Industry courses, LMS & placement support.",
    logo: eduLogo,
    link: "/edupravahaa",
    accent: "#2563EB",
    accentGlow: "rgba(37, 99, 235, 0.35)",
  },
];

function ProductCard({ product, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -6 }}
      className="hero-product-card-v2 group relative flex flex-col w-full max-w-[280px]"
      style={{
        "--card-accent": product.accent,
        "--card-glow": product.accentGlow,
      }}
    >
      {/* Logo on white — official brand assets */}
      <div className="hero-product-logo-stage">
        <img
          src={product.logo}
          alt={`${product.title} logo`}
          className="hero-product-logo-img"
          loading="eager"
        />
      </div>

      <div className="hero-product-card-body">
        <span
          className="hero-product-tag"
          style={{ color: product.accent }}
        >
          {product.tag}
        </span>
        <h3 className="hero-product-title">{product.title}</h3>
        <p className="hero-product-desc">{product.desc}</p>
        <Link to={product.link} className="hero-product-link">
          Explore <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </motion.div>
  );
}

export default function HeroProductVisual() {
  return (
    <div className="relative w-full min-h-[420px] flex items-center justify-center py-4">
      <div className="hero-visual-ring pointer-events-none" />
      <div className="absolute w-64 h-64 rounded-full bg-[#2563EB]/20 blur-[90px] pointer-events-none" />
      <div className="absolute w-48 h-48 rounded-full bg-[#26A9B5]/15 blur-[70px] translate-x-16 -translate-y-8 pointer-events-none" />

      <div className="relative z-10 flex flex-col sm:flex-row items-center justify-center gap-6 lg:gap-8 px-2">
        <ProductCard product={products[0]} delay={0.45} />
        <ProductCard product={products[1]} delay={0.58} />
      </div>
    </div>
  );
}
